var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.showCreateContractsFlag == false) ? _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true",
      "title": "Search Filter"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Add New Client Contract"
    },
    on: {
      "click": _vm.showCreateContract
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-2x",
    staticStyle: {
      "color": "red"
    }
  })])])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit('clientlist')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Company Short/Display Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('multiselect', {
    attrs: {
      "open-direction": "bottom",
      "options": _vm.companyNamelist,
      "placeholder": "Select Company Name",
      "name": "companyName",
      "label": "text",
      "track-by": "value",
      "multiple": false,
      "scroll": true
    },
    model: {
      value: (_vm.companyName),
      callback: function($$v) {
        _vm.companyName = $$v
      },
      expression: "companyName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Contract ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file-text-o' style='font-size: 12px'></i>"
    }
  }, [_c('multiselect', {
    attrs: {
      "open-direction": "bottom",
      "options": _vm.contractIdList,
      "name": "contractId",
      "placeholder": "Select Contract ID",
      "label": "text",
      "track-by": "value",
      "multiple": false,
      "scroll": true
    },
    model: {
      value: (_vm.contractId),
      callback: function($$v) {
        _vm.contractId = $$v
      },
      expression: "contractId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Client System ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.systemId),
      expression: "systemId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        isValidNumber: true
      }),
      expression: "{isValidNumber:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('systemId')
    },
    attrs: {
      "type": "text",
      "name": "systemId",
      "id": "systemId",
      "placeholder": "Enter Client System ID"
    },
    domProps: {
      "value": (_vm.systemId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.systemId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('systemId')),
      expression: "errors.has('systemId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('systemId')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file-text-o' style='font-size: 12px'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.statuslist,
      "selected-option": _vm.selectedstatus,
      "name": "status",
      "placeholder": "Select Contract Status"
    },
    on: {
      "select": _vm.selectStatus
    },
    model: {
      value: (_vm.statusSearch),
      callback: function($$v) {
        _vm.statusSearch = $$v
      },
      expression: "statusSearch"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Contract expiring in next days")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file-text-o' style='font-size: 12px'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.expirydayslist,
      "selected-option": _vm.selectedexpirydays,
      "name": "ContractExp",
      "placeholder": "Select Days"
    },
    on: {
      "select": _vm.selectExpiryDays
    },
    model: {
      value: (_vm.ContractExp),
      callback: function($$v) {
        _vm.ContractExp = $$v
      },
      expression: "ContractExp"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-left": "48rem"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.searchContract()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n                    "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetContract()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])])])])], 1)], 1)]), _vm._v(" "), _c('fieldset', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7",
    staticStyle: {
      "margin-bottom": "-8px"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Contract List")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('b', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Total Records: " + _vm._s(_vm.totalCount))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-bottom": "4px"
    }
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right",
      "padding-right": "2px"
    },
    attrs: {
      "type": "button",
      "title": "Download (XLSX)"
    },
    on: {
      "click": function($event) {
        _vm.downloadContractData()
      }
    }
  }, [_vm._v("Download (XLSX)")])])]), _vm._v(" "), (_vm.selectedContracts.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('b', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Selected Records: " + _vm._s(_vm.selectedContracts.length))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-bottom": "4px"
    }
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right",
      "padding-right": "2px"
    },
    attrs: {
      "type": "button",
      "title": "Update end date for selected contracts"
    },
    on: {
      "click": function($event) {
        _vm.openBulkUpdate()
      }
    }
  }, [_vm._v("Update end date  ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('custom-expandable-table', {
    attrs: {
      "columns": _vm.tableColumn,
      "isViewLogs": true,
      "selectCheckbox": true,
      "selectall": _vm.selectAll,
      "items": _vm.tableItems,
      "isEditHidden": true,
      "innerTableHeader": _vm.innerTableColumn,
      "offset": _vm.offset
    },
    on: {
      "customTableEvent": _vm.getCustomTableEvent
    }
  }, [(_vm.createTemplatesFlag == true) ? _c('div', [_c('clientcontractpdf', {
    attrs: {
      "selectedEditRow": _vm.selectedEditRow
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.Showdata == true) ? _c('div', [_c('clientcontractlog', {
    attrs: {
      "selectedEditRow": _vm.contractlog,
      "clientlogs": _vm.clientapprovallog
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalCount > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.showClientContractExtension = false
      }
    },
    model: {
      value: (_vm.showClientContractExtension),
      callback: function($$v) {
        _vm.showClientContractExtension = $$v
      },
      expression: "showClientContractExtension"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Update Client Contract Extension Date")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeContractExtension
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Start date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    staticStyle: {
      "width": "275px"
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "name": "fromdate",
      "disabled": true
    },
    model: {
      value: (_vm.fromdate),
      callback: function($$v) {
        _vm.fromdate = $$v
      },
      expression: "fromdate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Expiry Date ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'error': _vm.errors.has('todate')
    },
    staticStyle: {
      "width": "275px"
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "name": "expiry date",
      "format": "YYYY-MM-DD",
      "not-before": _vm.currentdate
    },
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('expiry date')),
      expression: "errors.has('expiry date')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('expiry date')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("Comments")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#449d42",
      "font-size": "11px"
    }
  }, [_vm._v("Note:Maximum Length 500 character")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comments),
      expression: "comments"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('comments')
    },
    attrs: {
      "name": "comments",
      "id": "comments",
      "placeholder": "Enter Comments"
    },
    domProps: {
      "value": (_vm.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comments = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('comments')),
      expression: "errors.has('comments')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter comment")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.validateextensiondate('updateContractExtension')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Update")])])], 1)])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md"
    },
    on: {
      "ok": function($event) {
        _vm.showBulkUpdate = false
      }
    },
    model: {
      value: (_vm.showBulkUpdate),
      callback: function($$v) {
        _vm.showBulkUpdate = $$v
      },
      expression: "showBulkUpdate"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoadingModal
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingModal = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Update Client Contract Extension Date")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeBulkUpdate
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Expiry Date ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'error': _vm.errors.has('todate')
    },
    staticStyle: {
      "width": "275px"
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "name": "expiry date",
      "format": "YYYY-MM-DD",
      "not-before": _vm.currentdate
    },
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('expiry date')),
      expression: "errors.has('expiry date')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('expiry date')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_c('label', [_vm._v("Comments")])]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comments),
      expression: "comments"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('comments')
    },
    attrs: {
      "name": "comments",
      "id": "comments",
      "placeholder": "Enter Comments"
    },
    domProps: {
      "value": (_vm.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comments = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#449d42",
      "font-size": "11px"
    }
  }, [_vm._v("Note:Maximum Length 500 character")]), _c('br'), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('comments')),
      expression: "errors.has('comments')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter comment")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.validateextensiondate('BulkUpdateContractExtension')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Update")])])], 1)])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md"
    },
    on: {
      "ok": function($event) {
        _vm.showModalActive = false
      }
    },
    model: {
      value: (_vm.showModalActive),
      callback: function($$v) {
        _vm.showModalActive = $$v
      },
      expression: "showModalActive"
    }
  }, [_c('b-card', [_c('form', {
    attrs: {
      "data-vv-scope": "activationform"
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeActiveModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("Reason")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('activationform.reason')
    },
    attrs: {
      "maxlength": "300",
      "name": "reason",
      "id": "reason",
      "placeholder": "Enter Reason"
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#449d42",
      "font-size": "11px"
    }
  }, [_vm._v("Note:Maximum Length 300 character")]), _c('br'), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('activationform.reason')),
      expression: "errors.has('activationform.reason')"
    }],
    staticClass: "text-danger errormsg",
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Please enter Reason")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "float": "right"
    }
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.activeAction
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v("   \n      "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeActiveModal
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Cancel")])])], 1)])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md"
    },
    on: {
      "ok": function($event) {
        _vm.showBulkUpdateRecords = false
      }
    },
    model: {
      value: (_vm.showBulkUpdateRecords),
      callback: function($$v) {
        _vm.showBulkUpdateRecords = $$v
      },
      expression: "showBulkUpdateRecords"
    }
  }, [_c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Updated Records")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeBulkUpdateRecords
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Client ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Contract Name ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status ")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.updateddaterecords), function(data, index) {
    return (_vm.updateddaterecords.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.data.clientid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.data.clientshortname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.data.contractname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.message))])]) : _vm._e()
  }), _vm._v(" "), (_vm.updateddaterecords.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])], 1) : _vm._e(), _vm._v(" "), (_vm.showCreateContractsFlag == true) ? _c('div', [_c('div', [_c('create-client-contract', {
    attrs: {
      "CompanyShortList": _vm.companyNamelist,
      "ContractTemplateList": _vm.contractTemplateList,
      "selectedEditRowData": _vm.selectedContractObj
    },
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1)]) : _vm._e()], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44c877a2","hasScoped":true}!./src/modules/clientmanagement/views/ClientContract/ClientContractListing/ClientContractListing.component.html
// module id = 728
// module chunks = 3